import BaseComponent from 'foundation/base-component';
import React from 'react';
import ReactDOM from 'react-dom';
import QualifiedPlayersListing from './QualifiedPlayersListing';
import { CONTROL_TYPE_CHECKLIST } from '../../listing/js/constants';

export default class QualifiedPlayersListingComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.listingElement = this.refs.listing;
        this.loadMoreElement = this.refs.loadmore;

        const endpointUrl = this.options.SearchApiUrl;
        if (!endpointUrl) {
            throw new Error('SearchApiUrl should be passed via options');
        }

        const predictiveEndpointUrl = this.options.PredictiveSearchApiUrl;
        if (!endpointUrl) {
            throw new Error('PredictiveSearchApiUrl should be passed via options');
        }

        const filtersConfig = this.options.Filters[0];

        const filters = [{
            type: CONTROL_TYPE_CHECKLIST,
            name: filtersConfig.name,
            options: filtersConfig.values,
            defaultValue: []
        }];


        this.playersListingOptions = {
            endpointUrl,
            predictiveEndpointUrl,
            filters,
        };
        this.init();
    }

    static getRequiredRefs() {
        return ['listing', 'loadmore'];
    }

    init() {
        ReactDOM.render(<QualifiedPlayersListing
            options={this.playersListingOptions} loadMoreElement={this.loadMoreElement} />, this.listingElement);
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }
}
